import { cn, NavItem } from "@iec-id/ui";
import { createLink } from "@tanstack/react-router";
import type { AnchorHTMLAttributes } from "react";

/**
 * Ссылки навигации, собранные из компонентов `@iec-id/ui`.
 *
 * `createLink` — единственный способ соединить UI-кит и роутер, не ломая
 * ни то, ни другое: компоненты кита рендерят обычный `<a href>` и про роутер
 * не знают (их вставляют и в чужие сервисы), а TanStack Router добавляет им
 * SPA-переход, префетч по наведению и подсветку активного раздела. Заменить
 * их кнопкой с `navigate()` нельзя — потеряются средний клик, «открыть
 * в новой вкладке» и предпросмотр адреса (rules/frontend-quality §11).
 */
export const NavItemLink = createLink(NavItem);

function SectionRowAnchor({ className, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement>) {
	return (
		<a
			// Плашка не выходит за колонку ящика: с `-mx-2` она упиралась в
			// края шторки, и подсветка активного раздела выглядела обрезанной
			// (замечание владельца 22.08.2026). Радиус тот же, что у карточек.
			className={cn(
				"iec-press-glyph block rounded-control px-3 text-fg",
				"transition-colors duration-150 ease-smooth hover:bg-sunken hover:text-fg",
				"focus-ring",
				className,
			)}
			{...rest}
		/>
	);
}

/** Строка-ссылка мобильного списка разделов: внутрь кладётся ListRow. */
export const SectionRowLink = createLink(SectionRowAnchor);
